import { DatabaseSections } from "../../../enums/DatabaseEnums";

export const DeleteConfirmConsts = (type: DatabaseSections) => {
  const TypeLabel =
    type === DatabaseSections?.CONTACTS
      ? "Contact"
      : type === DatabaseSections?.DOCUMENTS
      ? "Document"
      : type === DatabaseSections?.NOTES
      ? "Note"
      : type === DatabaseSections?.QUARRY
      ? "Quarry"
      : "Record";
  return {
    TITLE: `Delete ${TypeLabel}`,
    MODAL_WITH: "46.875rem",
    MESSAGE:
      type === DatabaseSections.QUARRY
        ? `Are you sure you want to delete this ${TypeLabel.toLowerCase()}?`
        : `This ${TypeLabel.toLowerCase()} will be permanently deleted. Are you sure you want to proceed?`,
    REASON_LABEL: "Reason",
    REASON_PLACEHOLDER: "Enter delete reason",
    REASON_NAME: "archiveReason",
    DELETE_SUCCESS: `${TypeLabel} deleted successfully`,
  };
};
